const DASHBOARD_PERF_PREFIXES = ['dashboard/'];

export function isDashboardPerfUrl(url: string | undefined): boolean {
  if (!url) return false;
  const normalized = url.replace(/^\/+/, '');
  return DASHBOARD_PERF_PREFIXES.some(
    (prefix) => normalized === prefix || normalized.startsWith(prefix)
  );
}

export function dashboardWidgetFromUrl(url: string): string {
  const normalized = url.replace(/^\/+/, '');
  if (normalized.startsWith('dashboard/')) {
    return normalized.slice('dashboard/'.length).split('/')[0] || 'unknown';
  }
  if (normalized.startsWith('forecast/')) {
    return normalized.split('/')[0] || 'forecast';
  }
  return normalized.split('/')[0] || 'unknown';
}
